import React, { useEffect } from "react";
import DialogueTable from "../components/dialogueTable";
const SoulMachines = ({ setLoader, loader }) => {
  return <DialogueTable setLoader={setLoader} loader={loader} />;
};

export default SoulMachines;
